import { equals } from '@execonline-inc/collections';
import { when } from '@execonline-inc/maybe-adapter';
import { observer } from 'mobx-react';
import { MulticheckStore } from '../../../../Multicheck/Store';
import { T } from '../../../../Translations';
import FlashError from '../../../FlashMessage/FlashError';
import ModalStore from '../../../Modal/Store';
import Footer from '../../../People/Participants/Skeleton/Footer';
import Table from '../../../People/Participants/Skeleton/Table';
import NoInvitations from './NoInvitations';
import InvitationsStore from './Store';
import InvitationStore from './Store/InvitationStore';
import { InvitationResource } from './Store/Types';
import InvitationsTable from './Table/index';

interface Props {
  store: InvitationsStore;
  invitationStore: InvitationStore;
  multicheckStore: MulticheckStore<InvitationResource>;
  modalStore: ModalStore;
}

function InvitationsBody({ store, invitationStore, multicheckStore, modalStore }: Props) {
  const { state } = store;
  switch (state.kind) {
    case 'initializing':
    case 'loading':
    case 'loading-more':
    case 'sorting':
      return (
        <div className="px-2.5 lg:px-12 py-7">
          <Table tableColCount={6} checkBoxRequirement={'required'} tableRowCount={15} />
          <Footer />
        </div>
      );
    case 'updating-query':
    case 'updating-search-parameters':
    case 'ready':
      const invitesCount = state.invitationsResource.payload.totalInvitations;
      return when(equals(0), invitesCount)
        .map(() => <NoInvitations store={store} multicheckStore={multicheckStore} />)
        .getOrElse(() => (
          <InvitationsTable
            store={store}
            invitationStore={invitationStore}
            invitationsResource={state.invitationsResource}
            multicheckStore={multicheckStore}
            modalStore={modalStore}
          />
        ));
    case 'error':
      return (
        <FlashError>
          <T kind={state.message} />
        </FlashError>
      );
  }
}

export default observer(InvitationsBody);
